import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import NotificationBell from './NotificationBell';
import './Header.css';

const Header = ({ user, onLogout }) => {
  const { t } = useTranslation();
  const roleLabel = {
    admin: t('users.admin'),
    manager: 'Manažér',
    supervisor: 'Supervízor',
    employee: 'Zamestnanec'
  }[user?.role] || t('users.user');
  
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img src="/logo.png" alt="ConstructAP s.r.o." className="company-logo" />
        </div>
        <div className="header-center">
          <h1 className="system-name">Dochádzový systém</h1>
        </div>
        <div className="header-right">
          {user && (
            <div className="user-info">
              <NotificationBell />

              <span className="user-name">{user.full_name || user.username || t('common.user')}</span>
              <span className="user-role">({roleLabel})</span>
              <button className="logout-btn" onClick={onLogout}>
                {t('nav.logout')}
              </button>
              <LanguageSelector />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;